import { Injectable } from '@angular/core';
import { APP_CONST } from '../../app.const';
import { RequestService } from '../../libraries/http/request.service';

@Injectable()
export class PromoRestService {
  baseURL = `${APP_CONST.API_MAIN}/admin/promo`;
  baseFileUrl = `${APP_CONST.API_FILE}`;

  request = this._request.new(this.baseURL);
  requestFile = this._request.new(this.baseFileUrl);

  constructor(private _request: RequestService) {}

  create(payload: any) {
    return this.request.post<any>(`/`, payload);
  }

  findAll(queryParams: any = {}) {
    return this.request.get<any>(`/`, { params: queryParams });
  }

  load(userId: string) {
    return this.request.get<any>(`${userId}`);
  }

  delete(promoId: string) {
    return this.request.delete<any>(`${promoId}`);
  }

  update(promoId: string, payload: any) {
    return this.request.put<any>(`${promoId}`, payload);
  }

  deleteImageById(id) {
    return this.requestFile.delete(id);
  }
}
